import React from 'react';
import { X, Check, ArrowRight, Sparkles } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const WhyQykfinSection = () => {
  const { t, isRTL } = useLanguage();

  return (
    <section className="py-20 md:py-24 bg-white">
      <div className="max-w-[1200px] mx-auto px-6">
        {/* Section Header */}
        <div className={`text-center mb-14 ${isRTL ? 'text-center' : ''}`}>
          <div className={`inline-flex items-center gap-2 px-3 py-1.5 bg-[#0071E3]/10 rounded-full mb-4 ${isRTL ? 'flex-row-reverse' : ''}`}>
            <Sparkles className="w-3.5 h-3.5 text-[#0071E3]" />
            <span className="text-[11px] font-semibold text-[#0071E3] uppercase tracking-wide font-inter">
              {t.whyQykfin.badge}
            </span>
          </div>
          <h2 className="font-dm text-3xl md:text-4xl lg:text-[42px] font-semibold tracking-tight text-[#1D1D1F] mb-4 leading-tight">
            {t.whyQykfin.title}
          </h2>
          <p className="text-lg text-[#6e6e73] font-inter max-w-2xl mx-auto">
            {t.whyQykfin.subtitle}
          </p>
        </div>

        {/* Comparison Cards */}
        <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {/* Traditional Apps */}
          <div className={`bg-[#F5F5F7] rounded-2xl p-8 ${isRTL ? 'text-right' : ''}`}>
            <div className={`flex items-center gap-3 mb-6 ${isRTL ? 'flex-row-reverse justify-end' : ''}`}>
              <div className="w-10 h-10 bg-[#86868b]/20 rounded-xl flex items-center justify-center">
                <X className="w-5 h-5 text-[#86868b]" />
              </div>
              <h3 className="font-dm text-xl font-semibold text-[#1D1D1F]">
                {t.whyQykfin.comparison.traditional.title}
              </h3>
            </div>
            
            <div className="space-y-4">
              {t.whyQykfin.comparison.traditional.points.map((point, index) => (
                <div 
                  key={index}
                  className={`flex items-center gap-3 ${isRTL ? 'flex-row-reverse justify-end' : ''}`}
                >
                  <div className="w-6 h-6 rounded-full bg-[#FF3B30]/10 flex items-center justify-center flex-shrink-0">
                    <X className="w-3.5 h-3.5 text-[#FF3B30]" />
                  </div>
                  <span className="text-[#6e6e73] font-inter text-[15px]">{point}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Qykfin Intelligence */}
          <div className={`bg-gradient-to-br from-[#0071E3]/5 to-[#5856D6]/5 rounded-2xl p-8 border border-[#0071E3]/20 ${isRTL ? 'text-right' : ''}`}>
            <div className={`flex items-center gap-3 mb-6 ${isRTL ? 'flex-row-reverse justify-end' : ''}`}>
              <div className="w-10 h-10 bg-gradient-to-br from-[#0071E3] to-[#5856D6] rounded-xl flex items-center justify-center">
                <Check className="w-5 h-5 text-white" />
              </div>
              <h3 className="font-dm text-xl font-semibold text-[#1D1D1F]">
                {t.whyQykfin.comparison.qykfin.title}
              </h3>
            </div>
            
            <div className="space-y-4">
              {t.whyQykfin.comparison.qykfin.points.map((point, index) => (
                <div 
                  key={index}
                  className={`flex items-center gap-3 ${isRTL ? 'flex-row-reverse justify-end' : ''}`}
                >
                  <div className="w-6 h-6 rounded-full bg-[#34C759]/10 flex items-center justify-center flex-shrink-0">
                    <Check className="w-3.5 h-3.5 text-[#34C759]" />
                  </div>
                  <span className="text-[#1D1D1F] font-inter text-[15px] font-medium">{point}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="mt-12 text-center">
          <a 
            href="#waitlist"
            className={`inline-flex items-center gap-2 px-6 py-3 bg-[#1D1D1F] text-white rounded-full font-medium text-[15px] hover:bg-[#1D1D1F]/90 transition-all hover:scale-[1.02] ${isRTL ? 'flex-row-reverse' : ''}`}
          >
            Experience the difference
            <ArrowRight className={`w-4 h-4 ${isRTL ? 'rotate-180' : ''}`} />
          </a>
        </div>
      </div>
    </section>
  );
};

export default WhyQykfinSection;
